import React, {useCallback, useState, useContext, createContext} from 'react'
import {AuditValidateForm} from '../../utils/AuditValidateForm'
import {AuditDetailsContext} from '../Modal/AuditDetails'
import {AuditPaneContext} from '../AuditPane'
import {GroupDetailsContext} from '../Modal/GroupDetails'
import {RecurringDetailsContext} from '../Modal/RecurringDetails'
import {AssignAuditContext} from '../Modal/AssignAudit'

const AuditModalBarContext = createContext()

function AuditModalBarContextProvider(props) {
  const auditDetails = useContext(AuditDetailsContext)
  const paneState = useContext(AuditPaneContext)
  const groupDetails = useContext(GroupDetailsContext)
  const recurring = useContext(RecurringDetailsContext)
  const assignAudit = useContext(AssignAuditContext)

  const [barState, setBarState] = useState({
    isNameLoading: false,
    uniqueNameCheck: true,
    activeCreateForm: 0,
    formState: true,
    errors: [],
  })
  const [editWarning, setEditWarning] = useState(false)
  const resetBarDetails = () => {
    setBarState({
      isNameLoading: false,
      uniqueNameCheck: true,
      activeCreateForm: 0,
      formState: true,
      errors: [],
    })
    setEditWarning(false)
  }
  // eslint-disable-next-line
  const modalState = {auditDetails, paneState, groupDetails, recurring, assignAudit, barState}
  const setActiveForm = useCallback(() => setBarState({...barState, activeCreateForm: 0}), [
    barState,
  ])

  const handleNameLoading = useCallback(() => {
    setBarState({
      ...barState,
      uniqueNameCheck: true,
    })
  }, [barState])

  const handleIncreaseDecreaseStep = useCallback(
    (updatedStep, err) => {
      var index = err
        .map(function(e) {
          return e.error_field
        })
        .indexOf('name')

      setBarState({
        ...barState,
        activeCreateForm: updatedStep,
        formState: true,
        uniqueNameCheck: index === -1 ? false : true,
        errors: err,
      })
    },
    [barState]
  )

  const handleChangeCreateForm = useCallback(
    step => {
      if (step === 0) {
        handleIncreaseDecreaseStep(0, [])
      } else if (step === 1) {
        AuditValidateForm(0, modalState).then(err => {
          if (err.length > 0) {
            handleIncreaseDecreaseStep(0, err)
          } else {
            handleIncreaseDecreaseStep(1, [])
          }
        })
      } else if (step === 2) {
        AuditValidateForm(0, modalState).then(err => {
          if (err.length > 0) {
            handleIncreaseDecreaseStep(0, err)
          } else {
            AuditValidateForm(1, modalState).then(err => {
              if (err.length > 0) {
                handleIncreaseDecreaseStep(1, err)
              } else {
                handleIncreaseDecreaseStep(2, [])
              }
            })
          }
        })
      } else if (step === 3) {
        AuditValidateForm(0, modalState).then(err => {
          if (err.length > 0) {
            handleIncreaseDecreaseStep(0, err)
          } else {
            AuditValidateForm(1, modalState).then(err => {
              if (err.length > 0) {
                handleIncreaseDecreaseStep(1, err)
              } else {
                AuditValidateForm(2, modalState).then(err => {
                  if (err.length > 0) {
                    handleIncreaseDecreaseStep(2, err)
                  } else {
                    handleIncreaseDecreaseStep(3, [])
                  }
                })
              }
            })
          }
        })
      }
    },
    [handleIncreaseDecreaseStep, modalState]
  )

  const handleStatusforPreviousNextButton = useCallback(
    val => {
      setBarState({
        ...barState,
        formState: false,
      })
      handleChangeCreateForm(
        barState.activeCreateForm >= 0 && barState.activeCreateForm < 4
          ? barState.activeCreateForm + val
          : 0
      )
    },
    [setBarState, handleChangeCreateForm, barState]
  )
  const value = {
    ...barState,
    editWarning,
    handleStatusforPreviousNextButton,
    handleIncreaseDecreaseStep,
    handleChangeCreateForm,
    handleNameLoading,
    setActiveForm,
    resetBarDetails,
    setEditWarning,
    setBarState,
  }

  return (
    <AuditModalBarContext.Provider value={value}>{props.children}</AuditModalBarContext.Provider>
  )
}

const AuditModalBarContextConsumer = AuditModalBarContext.Consumer

export {AuditModalBarContext, AuditModalBarContextProvider, AuditModalBarContextConsumer}
